// extracted by mini-css-extract-plugin
module.exports = {"legend":"PNLChart_legend_2aNvl","dot":"PNLChart_dot_T90R7","disabled":"PNLChart_disabled_3nfyB","dotCircle":"PNLChart_dotCircle_2_knA"};